/**
 * Created by istvan.rozsa on 2017. 04. 25..
 */

import tagsInputController from './tags-input-controller';
/**
 *
 * @param tagsModel: az inputon található model, amibe a tag-eket teszi majd bele
 * @param validationPattern: regexp
 * @param formInput: a form model, amin majd állítgatja a valid értéket
 */
export default function (app) {
	app.component('ebizTagsInput', {
		bindings: {
			tagsModel: '=',
			formInput: '=',
			validationPattern: '=',
			hintList: '<',
			maxEmailLength: '@?',
			mappedEmails: '<'
		},
		templateUrl: 'common/ebiz-tags-input',
		controller: ['$scope', tagsInputController]
	});
};
